module.exports = __webpack_public_path__ + "img/hy4.42e0a7bf.png";